/*
* @Author: hudichao
* @Date:   2016-12-23 11:33:18
* @Last Modified by:   hudichao
* @Last Modified time: 2016-12-23 15:53:51
*/

'use strict';

function accDiv(arg1, arg2) {
    var r1, r2;
    var t1 = 0;
    var t2 = 0;

    try {
        t1 = arg1.toString().split('.')[1].length;
    } catch (e) {}

    try {
        t2 = arg2.toString().split('.')[1].length;
    } catch (e) {}

    r1 = Number(arg1.toString().replace('.', ''));
    r2 = Number(arg2.toString().replace('.', ''));
    return r1 / r2 * Math.pow(10, t2 - t1);
}

function accMul(arg1, arg2) {
    var m = 0;
    var s1 = arg1.toString();
    var s2 = arg2.toString();

    try {
        m += s1.split('.')[1].length;
    } catch (e) {}

    try {
        m += s2.split('.')[1].length;
    } catch (e) {}

    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

function accAdd(arg1, arg2) {
    var r1, r2, m;
    try {
        r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }

    try {
        r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }

    m = Math.pow(10, Math.max(r1, r2));
    return (arg1 * m + arg2 * m) / m;
}

function accSub(arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split('.')[1].length;
    } catch (e) {
        r1 = 0;
    }

    try {
        r2 = arg2.toString().split('.')[1].length;
    } catch (e) {
        r2 = 0;
    }

    m = Math.pow(10, Math.max(r1, r2));

    return (arg1 * m - arg2 * m) / m;
}

var process = {
    accAdd: accAdd,
    accSub: accSub,
    accMul: accMul,
    accDiv: accDiv
};

function compute(arg1, operator, number) {
    if (arg1 === undefined) {
        return undefined;
    }
    var operatorStr;
    switch (operator) {
        case '+':
            operatorStr = 'accAdd';
            break;
        case '-':
            operatorStr = 'accSub';
            break;
        case '*':
            operatorStr = 'accMul';
            break;
        case '/':
            operatorStr = 'accDiv';
            break;
    }
    if (!operatorStr) {
        console.error('程序错误，输入+-*/中的一个');
        return;
    }
    return process[operatorStr](arg1, number);
}

module.exports = {
    compute: compute
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/souche-util/lib/math.js
// module id = BPyY
// module chunks = 11